/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edit_DetailsInputs */

const cs_workflow_edit_details = /** @type {(inputs: Workflow_Edit_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podrobnosti`)
};

const en_workflow_edit_details = /** @type {(inputs: Workflow_Edit_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Workflow_Edit_DetailsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edit_details = /** @type {((inputs?: Workflow_Edit_DetailsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edit_DetailsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edit_details(inputs)
	return cs_workflow_edit_details(inputs)
});